import { useFormContext } from 'react-hook-form';
import LoadingSpinner from 'components/loading/LoadingSpinner';

const SubmitButton = (props) => {
  const { formState } = useFormContext();
  const { children, disabled = false, additionalClasses = '', saving: isSaving, dataTestId } = props;
  const { isSubmitting } = formState;

  const disable = disabled && disabled === false ? false : disabled;

  const getClass = () => {
    if (isSaving) {
      return 'is-loading';
    }
    if (isSubmitting) {
      return 'is-loading';
    }
    return '';
  };

  const getContent = () => {
    if (isSaving) {
      return <LoadingSpinner addSeparator bg={false} />;
    }
    if (isSubmitting) {
      return <LoadingSpinner addSeparator bg={false} />;
    }
    return <span>{children}</span>;
  };

  return (
    <button
      type="submit"
      id="submitFormButton"
      disabled={disable}
      data-testid={isSubmitting || isSaving ? 'loading-submit-button' : dataTestId}
      className={`Button u-posRelative u-fsSm Button--primary ${getClass()} ${additionalClasses}`}
    >
      {getContent()}
    </button>
  );
};

export default SubmitButton;
